import Link from 'next/link'
import React from 'react'
import { useQuery } from 'react-query'
import { motion } from 'framer-motion'
import { GET_CATEGORIES } from '~src/api/categories'
import { graphQLClientGET } from '~src/api/graphql'
import { ButtonMain } from '~src/components/global/Button/ButtonMain/ButtonMain'
import { _format, cleanDoubleHttps, encode } from '~src/util'
import TitleAni from './TitleAni'

const formatNumber = (num: number) => {
  return num?.toLocaleString('de-DE') || '0'
}

export const CatalogsSection = ({ id }: { id: string | number }) => {
  // Danh sách nhóm phụ tùng
  const {
    data: dataSpareParts = [],
  }: {
    data?: TChildrenCategories[]
    isLoading?: boolean
  } = useQuery({
    queryKey: ['getSpareParts'],
    queryFn: async () => {
      const data = (await graphQLClientGET.request(GET_CATEGORIES, {
        eq: encode(id as string),
      })) as TCategories
      return data.categories?.items[0]?.children
    },
    enabled: !!id,
  })

  return (
    <div className="catalog-section">
      <div className="bg-left">
        <img src="/image/bg-catalog-left.png" alt="" />
      </div>
      <div className="bg-right">
        <img src="/image/bg-catalog-left.png" alt="" />
      </div>

      <div className="containers">
        <div className="title relative max-md:flex-col max-md:!items-center max-md:!justify-center">
          <div className="title-left">
            <div className="icon-center icon-brand max-md:mx-auto">
              <img src="/image/ic-brand.svg" alt="" />
            </div>
            <TitleAni title="DANH MỤC SẢN PHẨM"></TitleAni>
          </div>
          <div className="title-right max-md:!ml-[0]">
            <Link
              href={{
                pathname: '/catalog-category',
              }}
            >
              <a>
                <ButtonMain background="green" type="button" className="right-0 bottom-0">
                  <div className="text-all">
                    <span>Xem tất cả</span>
                  </div>
                </ButtonMain>
              </a>
            </Link>
          </div>
        </div>
        <div className="content-home-catalog">
          <div className="gallery-top">
            {dataSpareParts?.slice(0, 2).map((item: TChildrenCategories, index: number) => (
              <motion.div
                className="items item-left"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, ease: 'easeOut', delay: 0.1 + index * 0.1 }}
                key={item?.id}
              >
                <div className="img">
                  <img src={cleanDoubleHttps(item?.image)} alt="" />
                  <div className="inner-content">
                    <div className="icon">
                      <img src="/icons/008-pistons.svg" alt="" />
                    </div>
                    <div className="txt">
                      <span>{item?.name ?? ''}</span>
                    </div>
                  </div>
                  <Link
                    href={{
                      pathname: `/accessories/${_format.converStringToString(
                        item?.url_key as string
                      )}`,
                    }}
                  >
                    <div className="button-center">
                      <div className="inner-button">
                        <div className="inner-text">
                          <div className="total">{formatNumber(item?.product_count ?? 0)}</div>
                          <div className="text">sản phẩm</div>
                          <div className="icon">
                            <img src="/icons/right-up-red.svg" alt="" className="mx-auto" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </motion.div>
            ))}
            {/* <div className="items item-right">
              <motion.div
                className="item"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, ease: 'easeOut', delay: 0.2 }}
              >
                <div className="img">
                  <img src={cleanDoubleHttps(dataSpareParts[1]?.image)} alt="" />
                  <div className="inner-content">
                    <div className="icon">
                      <img src="/icons/008-pistons.svg" alt="" />
                    </div>
                    <div className="txt">
                      <span>
                        {!!dataSpareParts && !!dataSpareParts[1] ? dataSpareParts[1]?.name : ''}
                      </span>
                    </div>
                  </div>
                  <Link
                    href={{
                      pathname: `/accessories/${_format.converStringToString(
                        dataSpareParts?.[1]?.url_key as string
                      )}`,
                    }}
                  >
                    <div className="button-center">
                      <div className="inner-button">
                        <div className="inner-text">
                          <div className="total">
                            {!!dataSpareParts && dataSpareParts[1]
                              ? formatNumber(dataSpareParts[1]?.product_count)
                              : 0}
                          </div>
                          <div className="text">sản phẩm</div>
                          <div className="icon">
                            <img src="/icons/right-up-red.svg" alt="" className="mx-auto" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </motion.div>
              <motion.div
                className="item"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, ease: 'easeOut', delay: 0.3 }}
              >
                <div className="img">
                  <img src={cleanDoubleHttps(dataSpareParts[2]?.image)} alt="" />
                  <div className="inner-content">
                    <div className="icon">
                      <img src="/icons/008-pistons.svg" alt="" />
                    </div>
                    <div className="txt">
                      <span>
                        {!!dataSpareParts && !!dataSpareParts[2] ? dataSpareParts[2]?.name : ''}
                      </span>
                    </div>
                  </div>
                  <Link
                    href={{
                      pathname: `/accessories/${_format.converStringToString(
                        dataSpareParts?.[2]?.url_key as string
                      )}`,
                    }}
                  >
                    <div className="button-center">
                      <div className="inner-button">
                        <div className="inner-text">
                          <div className="total">
                            {' '}
                            {!!dataSpareParts && !!dataSpareParts[2]
                              ? formatNumber(dataSpareParts[2]?.product_count)
                              : 0}
                          </div>
                          <div className="text">sản phẩm</div>
                          <div className="icon">
                            <img src="/icons/right-up-red.svg" alt="" className="mx-auto" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </motion.div>
            </div> */}
          </div>
          <div className="gallery-bottom">
            <div className="w-full gap-[1.2rem] sm:gap-[2.4rem] flex">
              {dataSpareParts?.slice(2, 5).map((item: TChildrenCategories, index: number) => {
                return (
                  <React.Fragment key={item?.id ?? index}>
                    <motion.div
                      className="item !w-1/3"
                      initial={{ opacity: 0, y: 30 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true, amount: 0.3 }}
                      transition={{
                        duration: 0.5,
                        ease: 'easeOut',
                        delay: 0.4 + (index - 3) * 0.1,
                      }}
                    >
                      <div className="img">
                        <img src={cleanDoubleHttps(item?.image)} alt="" />
                        <div className="inner-content">
                          <div className="icon">
                            <img src="/icons/008-pistons.svg" alt="" />
                          </div>
                          <div className="txt">
                            <span>{item?.name}</span>
                          </div>
                        </div>
                        <Link
                          href={{
                            pathname: `/accessories/${_format.converStringToString(item?.url_key)}`,
                          }}
                        >
                          <div className="button-center">
                            <div className="inner-button">
                              <div className="inner-text">
                                <div className="total">
                                  {formatNumber(item?.product_count || 0)}
                                </div>
                                <div className="text">sản phẩm</div>
                                <div className="icon">
                                  <img src="/icons/right-up-red.svg" alt="" className="mx-auto" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </motion.div>
                  </React.Fragment>
                )
              })}
            </div>
            {/* <div className="xs:w-1/2 w-full gap-[1.2rem] sm:gap-[2.4rem] flex">
              {dataSpareParts?.map((item: TChildrenCategories, index: number) => (
                <motion.div
                  key={item?.id}
                  className="item !w-1/2"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{
                    duration: 0.5,
                    ease: 'easeOut',
                    delay: 0.6 + (index - 5) * 0.1,
                  }}
                >
                  <div className="img">
                    <img src={cleanDoubleHttps(item?.image)} alt="" />
                    <div className="inner-content">
                      <div className="icon">
                        <img src="/icons/008-pistons.svg" alt="" />
                      </div>
                      <div className="txt">
                        <span>{item?.name}</span>
                      </div>
                    </div>
                    <Link
                      href={{
                        pathname: `/accessories/${_format.converStringToString(item?.url_key)}`,
                      }}
                    >
                      <div className="button-center">
                        <div className="inner-button">
                          <div className="inner-text">
                            <div className="total">{formatNumber(item?.product_count || 0)}</div>
                            <div className="text">sản phẩm</div>
                            <div className="icon">
                              <img src="/icons/right-up-red.svg" alt="" className="mx-auto" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </motion.div>
              ))}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

const ItemGallery = ({ dataSpareParts, classCustom }: any) => {
  return (
    <div className={`item ${classCustom}`}>
      <div className="img">
        <img src={cleanDoubleHttps(dataSpareParts?.image)} alt="" />
        <div className="inner-content">
          <div className="icon">
            <img src="/icons/008-pistons.svg" alt="" />
          </div>
          <div className="txt">
            <span>{!!dataSpareParts && !!dataSpareParts ? dataSpareParts?.name : ''}</span>
          </div>
        </div>
        <Link
          href={{
            pathname: `/accessories/${_format.converStringToString(
              dataSpareParts?.url_key as string
            )}`,
          }}
        >
          <div className="button-center">
            <div className="inner-button">
              <div className="inner-text">
                <div className="total">
                  {!!dataSpareParts && dataSpareParts
                    ? formatNumber(dataSpareParts?.product_count)
                    : 0}
                </div>
                <div className="text">sản phẩm</div>
                <div className="icon">
                  <img src="/icons/right-up-red.svg" alt="" className="mx-auto" />
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </div>
  )
}
